const compare = require('./compare')
const rcompare = (a, b, loose) => compare(b, a, loose)
module.exports = rcompare



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/rcompare.js
// module id = 1418
// module chunks = 0